(function () {
    "use strict";

    angular.module("showcaseApp").directive("voiceInput", voiceInput);

    voiceInput.$inject = [];

    function voiceInput() {
        return {
            restrict: "E",
            scope: {
                ngModel: "=",
                contextPrompt: "@?",
                allowGeneration: "<?",
            },
            templateUrl:
                "app/shared/directives/voice-input/templates/voice-input.html",
            controller: "VoiceInputController",
            controllerAs: "vm",
            bindToController: true,
        };
    }
})();
